import { Pipe, PipeTransform } from '@angular/core';
import { DateFunctions } from '@hub/common/DateFunctions';
import { eDateFormat } from '@hub/generated/enums';
import { CurrentUserService } from '@hub/services/CurrentUserService';

@Pipe({ name: 'toDateTimeString' })
export class DateTimePipe implements PipeTransform {
    constructor(
        private userService: CurrentUserService,
    ) {
    }

    public transform(dateString: string, format: eDateFormat): string {
      return DateFunctions.toDateTimeString(dateString, this.userService.GetTimeZone, format);
    }
}
